export const guestReviewConfig = {
  /* -------------------------------- GET ---------------------------------- */
  validateReviewToken: {
    key: "validateReviewToken",
    url: (params) => `/api/v1/guest-review/validate/${params?.token}`,
    method: "GET",
    options: {
      staleTime: 0,
      gcTime: 0,
      refetchOnWindowFocus: false,
      enabled: false,
    },
  },

  getGuestReviews: {
    key: "getGuestReviews",
    url: "/api/v1/guest-review",
    method: "GET",
    options: {
      staleTime: 60_000,
      gcTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
      keepPreviousData: true,
    },
  },

  getGuestReviewStats: {
    key: "getGuestReviewStats",
    url: "/api/v1/guest-review/stats",
    method: "GET",
    options: {
      staleTime: 60_000,
      gcTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
    },
  },

  /* -------------------------------- POST --------------------------------- */
  submitGuestReview: {
    key: "submitGuestReview",
    url: "/api/v1/guest-review/submit",
    method: "POST",
    options: {
      retry: false,
      invalidateKeys: ["getGuestReviews"],
    },
  },
};
